// extracted by mini-css-extract-plugin
export default {"galleryContainer":"MosaicGallery_galleryContainer__aBKlD","galleryImage":"MosaicGallery_galleryImage__hJbJK"};